import Decimal from 'decimal.js';

// Banker's rounding (round-half-to-even), high precision for intermediate math.
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_EVEN });

export type DecimalInput = Decimal.Value;

export { Decimal };

/** Money amounts: 2 decimal places. */
export function round2(value: DecimalInput): Decimal {
  return new Decimal(value).toDecimalPlaces(2);
}

/** Quantities: 3 decimal places (base units). */
export function round3(value: DecimalInput): Decimal {
  return new Decimal(value).toDecimalPlaces(3);
}

/** Per-base-unit rates (e.g. purchase price of a batch): 4 decimal places. */
export function round4(value: DecimalInput): Decimal {
  return new Decimal(value).toDecimalPlaces(4);
}

/** Formats a Decimal as the canonical API wire string (fixed 2 decimals, e.g. "1234.50"). */
export function toMoneyString(value: DecimalInput): string {
  return round2(value).toFixed(2);
}

/** Formats a Decimal as the canonical API wire string for quantities (fixed 3 decimals). */
export function toQtyString(value: DecimalInput): string {
  return round3(value).toFixed(3);
}
